import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {UsefulFunctionsService} from "../useful-functions.service";
import {ProductsDataComponent} from "../products-data/products-data.component";
import {environment} from "../../environments/environment";
import {ENTER} from "@angular/cdk/keycodes";
import {MatChipInputEvent} from "@angular/material/chips";
import {ChipsListComponent} from "../chips-list/chips-list.component";
import {MatAutocompleteSelectedEvent, MatAutocomplete} from "@angular/material/autocomplete";

//TODO create as a global interface?
interface chipElement {
  arrayString: string[];
  formArrayName: string;
}


@Component({
  selector: 'app-inci-details',
  templateUrl: './inci-details.component.html',
  styleUrls: ['./inci-details.component.scss']
})
export class InciDetailsComponent implements OnInit {

  getINCIInformationForm = this.fb.group({
    range: this.fb.group({
      startDate: [''/*,  Validators.required*/],
      endDate: ['',  /*Validators.required*/],
    }),
    INCIs_exact: this.fb.array([]),
    INCIs_contain: this.fb.array([]),
    CAS_no: this.fb.array([]),
    functions: this.fb.array([]),
    restrictions: this.fb.array([])
  });

  results: any //The JSON object that will contain the results from the request

  //Chips boolean, TODO move into the chip list component
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER];

  INCIExactMatchCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('INCIExactMatchInput') INCIExactMatchInput: ElementRef<HTMLInputElement>;
  INCIExactMatchChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'INCIs_exact',
  }

  INCIContainCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('INCIContainsInput') INCIContainInput: ElementRef<HTMLInputElement>;
  INCIContainChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'INCIs_contain',
  }

  CASCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('CASInput') CASInput: ElementRef<HTMLInputElement>;
  CASChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'CAS_no',
  }

  functionCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('functionInput') functionInput: ElementRef<HTMLInputElement>;
  functionChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'functions',
  }
  possibleFunctions: any = [] //Array that will contain the different functions that can be chosen
  functions: any = [] //Array that will contain the different functions that can be chosen

  restrictionCtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('restrictionInput') restrictionInput: ElementRef<HTMLInputElement>;
  restrictionChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'restrictions',
  }
  possibleRestrictions: any = ["II","III","IV","V","IV"] //Array that will contain the different functions that can be chosen
  restrictions: any = ["II","III","IV","V","IV"] //Array that will contain the different functions that can be chosen

  inputElements = [] //Array that will gather the different input defined as ElementRef

  //Extension Panel steps
  step = 0;
  INCIExactMatchSelected: boolean = false // Boolean marking if the step has been done or not
  INCIContainSelected: boolean = false // Boolean marking if the step has been done or not
  CASSelected: boolean = false // Boolean marking if the step has been done or not
  functionSelected: boolean = false // Boolean marking if the step has been done or not
  restrictionSelected: boolean = false // Boolean marking if the step has been done or not

  limit = 5000 //The max number of products that can be retrieve, not to be changed as defined as 1000 in the API
  skip = 0 //The number of products to not retrieve
  currentMax = 0 //The current highest number of products
  nextSkip = 5000 //The next amount of products that will be retrieved

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  constructor(private fb: FormBuilder,
              public httpClient: HttpClient,
              public usefulFunctionsService: UsefulFunctionsService,
              public chipListComponent: ChipsListComponent) {

    this.INCIExactMatchCtrl.valueChanges.subscribe(async (inci: any) => {
      this.usefulFunctionsService.possibleINCIs = await this.usefulFunctionsService.searchIngredients(inci)
    })

    //Apply the filter function on the chips inputs
    this.functionCtrl.valueChanges.subscribe(async (value: any) => {
      if (value) {
        const filterValue = value.toLowerCase();
        this.possibleFunctions = this.functions.filter(elm => elm.toLowerCase().indexOf(filterValue) === 0)
      } else {
        this.possibleFunctions = this.functions
      }
    })

  }

  async ngOnInit(): Promise<void> {

    // Retrieve the functions from the database
    var functions: any = await this.httpClient.get(environment.apiUrl+"getAllFunctions").toPromise()
    this.possibleFunctions = functions.map(fct => fct.name)
    this.functions = functions.map(fct => fct.name)

  }

  /**
   * Set the dates as the full range
   */
  public selectFullRange() {
    var rangeGroup = (this.getINCIInformationForm.get('range') as FormGroup)
    rangeGroup.setValue({startDate: new Date('2009,01,01'), endDate:new Date()})
    this.nextStep()
  }

  /**
   * Manage the add event from a MapChipInput
   * @param event,MatChipInputEvent, the event of adding a chip
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  add(event: MatChipInputEvent, formControl, array, formArrayName, inci:boolean): void {
    const input = event.input;
    const value = event.value;

    if (formArrayName == 'INCIs_exact') this.INCIExactMatchSelected = true
    if (formArrayName == 'INCIs_contain') this.INCIContainSelected = true
    if (formArrayName == 'CAS_no') this.CASSelected = true


    this.chipListComponent.addChip(value, null, array, formArrayName, formControl, this.getINCIInformationForm, inci)

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  /**
   * Manage the add event from a MatAutocompleteSelectedEvent, by adding a chip and the value into the formControl
   * @param event, MatAutocompleteSelectedEvent, the selection event
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  selected(event: MatAutocompleteSelectedEvent, formControl, array, formArrayName, inci:boolean): void {

    this.inputElements = [this.INCIExactMatchInput, this.functionInput] //Pass all the inputs that can be selected in the array

    const value = inci ? event.option.viewValue: event.option.value;
    const viewValue = event.option.viewValue;

    if (formArrayName == 'functions') this.functionSelected = true
    if (formArrayName == 'restrictions') this.restrictionSelected = true
    if (formArrayName == 'INCIs_exact') this.INCIExactMatchSelected = true

    //Clean all the inputs value as we cannot select the current input as native element
    this.inputElements.forEach(nativeElement => {
      nativeElement.nativeElement.value = ''
    })

    this.chipListComponent.addChip(value, viewValue, array, formArrayName, formControl, this.getINCIInformationForm, inci)
  }

  //TODO put in one function the skips and selectAll
  /**
   * Select all the INCIs
   */
  public selectAllINCIs() {
    this.INCIExactMatchSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.INCIExactMatchChipElement, this.getINCIInformationForm)
    this.nextStep()
  }

  /**
   * Skip the INCI contain step
   */
  public skipINCIsContains() {
    this.INCIContainSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.INCIContainChipElement, this.getINCIInformationForm)
    this.nextStep()
  }

  /**
   * Skip the INCI contain step
   */
  public skipCASNumber() {
    this.CASSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.CASChipElement, this.getINCIInformationForm)
    this.nextStep()
  }

  /**
   * Skip the function step
   */
  public skipFunction() {
    this.functionSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.functionChipElement, this.getINCIInformationForm)
    this.nextStep()
  }

  /**
   * Skip the function step
   */
  public skipRestriction() {
    this.restrictionSelected = true
    // remove all the chips as an empty array means the selection of all
    this.chipListComponent.clearChipElement(this.restrictionChipElement, this.getINCIInformationForm)
    this.nextStep()
  }

  /**
   * Manage the form submission
   */
  async onSubmit() {

    this.results = null
    this.getINCIInformationForm.value.skip = this.skip

    //Pass the range object value into direct values to fit the api request structure
    this.getINCIInformationForm.value.startDate = this.getINCIInformationForm.value.range.startDate
    this.getINCIInformationForm.value.endDate = this.getINCIInformationForm.value.range.endDate

    var tokenData: any = await this.httpClient.post(environment.apiUrl+"temptoken", {"id":sessionStorage.getItem('id')}).toPromise()

    var bodyPredefinedForTest = {"skip":0,
      "limit":0,
      "startDate": null,
      "endDate": "2021,01,01",
      "INCIs_exact":[],
      "INCIs_contain":["AQUA", "PARABEN"],
      "CAS_no": [],
      "functions": [],
      "restrictions":[]
    }


    //ToPromise convert an Observable to a Promise (more info here: https://blog.fullstacktraining.com/angular-promise-vs-observable/)
    var data = await this.httpClient.post(environment.apiUrl+"getINCIData",
      //bodyPredefinedForTest,
      this.getINCIInformationForm.value,
      {"headers": {
          "Authorization": "Bearer " + tokenData.token,
          "Content-Type": "application/json"
        }}).toPromise()

    this.results = data
    this.currentMax = this.skip +this.limit > this.results.total ? this.results.total : (this.skip +this.limit)
    this.nextSkip =  this.results.total - this.currentMax < this.limit ? this.results.total - this.currentMax : this.limit
  }

  /**
   * Retrieve the next batch of products
   */
  getNextBatch() {
    this.skip += this.limit
    this.onSubmit()
  }
  /**
   * Retrieve the previous batch of products
   */
  getPreviousBatch() {
    this.skip -= this.limit
    this.onSubmit()
  }


}
